import { noComma } from "./with-comma";
const NUM_KOR = ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"];
const DAN_KOR = ["", "십", "백", "천"];
/**
 * 조 단위까지의 숫자를 한글로 변환하고 붙일 문자를 뒤에 표기하여 반환
 * @example toKorean('78000000', ' 달러') -> '칠천팔백만 달러'
 */
export function toKorean(val, suffix) {
    const parsed = parseInt(String(noComma(val)));
    if (isNaN(parsed))
        return "NaN";
    if (parsed === 0)
        return "";
    const str = parsed.toString();
    const groupUnits = ["", "만", "억", "조"];
    let result = "";
    for (let g = 0; g * 4 < str.length; g++) {
        const start = Math.max(0, str.length - (g + 1) * 4);
        const end = str.length - g * 4;
        const group = str.slice(start, end);
        let groupStr = "";
        for (let j = 0; j < group.length; j++) {
            const digit = Number(group.charAt(j));
            if (digit === 0)
                continue;
            const posFromRight = group.length - 1 - j;
            groupStr += NUM_KOR[digit] + DAN_KOR[posFromRight];
        }
        if (groupStr !== "") {
            result = groupStr + groupUnits[g] + result;
        }
    }
    return suffix ? result + suffix : result;
}
